module.exports = __webpack_public_path__ + "resources/c3903aac7f8a93a31e03ac79d81b0578.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/super-villain.png
// module id = 226
// module chunks = 0